// src/components/ErrorBoundary.jsx

import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ errorInfo });
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null, errorInfo: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={styles.container}>
                    <div style={styles.card}>
                        <div style={styles.iconCircle}>
                            <span style={styles.icon}>⚠️</span>
                        </div>
                        <h1 style={styles.title}>Bir Şeyler Ters Gitti</h1>
                        <p style={styles.description}>
                            Üzgünüz, beklenmeyen bir hata oluştu. Lütfen sayfayı yenilemeyi deneyin
                            veya sorun devam ederse yönetici ile iletişime geçin.
                        </p>
                        {this.state.error && (
                            <details style={styles.details}>
                                <summary style={styles.summary}>Hata Detayları</summary>
                                <pre style={styles.errorText}>
                                    {this.state.error.toString()}
                                    {this.state.errorInfo?.componentStack}
                                </pre>
                            </details>
                        )}
                        <div style={styles.actions}>
                            <button style={styles.retryButton} onClick={this.handleRetry}>
                                🔄 Yeniden Dene
                            </button>
                            <button style={styles.homeButton} onClick={() => window.location.href = '/dashboard'}>
                                🏠 Ana Sayfaya Dön
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        padding: '24px'
    },
    card: {
        background: 'white',
        borderRadius: '24px',
        padding: '48px',
        maxWidth: '520px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)',
        border: '1px solid #e2e8f0'
    },
    iconCircle: {
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #fef3c7, #fde68a)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 24px'
    },
    icon: {
        fontSize: '36px'
    },
    title: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#0f172a',
        margin: '0 0 12px'
    },
    description: {
        fontSize: '15px',
        color: '#64748b',
        lineHeight: '1.6',
        margin: '0 0 24px'
    },
    details: {
        textAlign: 'left',
        marginBottom: '24px',
        background: '#fef2f2',
        borderRadius: '12px',
        padding: '16px',
        border: '1px solid #fecaca'
    },
    summary: {
        cursor: 'pointer',
        fontSize: '13px',
        fontWeight: '600',
        color: '#991b1b',
        marginBottom: '8px'
    },
    errorText: {
        fontSize: '12px',
        color: '#b91c1c',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        margin: '8px 0 0',
        maxHeight: '200px',
        overflow: 'auto'
    },
    actions: {
        display: 'flex',
        gap: '12px',
        justifyContent: 'center',
        flexWrap: 'wrap'
    },
    retryButton: {
        padding: '12px 28px',
        background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
        color: 'white',
        border: 'none',
        borderRadius: '12px',
        fontSize: '15px',
        fontWeight: '600',
        cursor: 'pointer',
        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
        transition: 'all 0.2s'
    },
    homeButton: {
        padding: '12px 28px',
        background: 'white',
        color: '#374151',
        border: '1px solid #d1d5db',
        borderRadius: '12px',
        fontSize: '15px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s'
    }
};

export default ErrorBoundary;
